import "./msalAuthenticationService";
import "./googleAuthenticationService";
let serviceInUse = null;
export const setAuthentication = (service) => {
    serviceInUse = service;
};
export const getAuthentication = () => serviceInUse;
